import {OpenCommentState} from 'atoms/comment';
import {LexicalEditor} from 'lexical';
import {useEffect, useRef} from 'react';

export const usePlanningUrlThreadActivation = ({
  urlThreadId,
  locationKey,
  navigationState,
  planningId,
  planningDocId,
  editorContainerEl,
  planningEditor,
  isDocumentSynced,
  isEditorStateReady,
  openComment,
}: {
  urlThreadId: string | null;
  locationKey: string;
  navigationState: unknown;
  planningId: string | number | undefined;
  planningDocId: string;
  editorContainerEl: HTMLElement | null;
  planningEditor: LexicalEditor | null;
  isDocumentSynced: boolean;
  isEditorStateReady: boolean;
  openComment: (comment: OpenCommentState) => void;
}) => {
  const lastUrlThreadActivationRef = useRef<string | null>(null);
  const isNotificationNavigation =
    (navigationState as {source?: unknown} | null)?.source === 'notification';
  const isCurrentPlanningDocReady =
    String(planningId ?? '') === planningDocId &&
    Boolean(editorContainerEl && planningEditor && isDocumentSynced && isEditorStateReady);

  useEffect(() => {
    if (!urlThreadId) return;

    const activationKey = `${locationKey}:${urlThreadId}`;
    if (lastUrlThreadActivationRef.current === activationKey) return;

    lastUrlThreadActivationRef.current = activationKey;
    openComment({
      threadId: urlThreadId,
      source: isNotificationNavigation && isCurrentPlanningDocReady ? 'notification' : 'url',
    });
  }, [isCurrentPlanningDocReady, isNotificationNavigation, locationKey, openComment, urlThreadId]);
};
